import { IMethodRouter } from 'runtime/methodrouter';

export class SaveRequested {
    static eventName() { return 'SaveRequested'; }

    eventName = SaveRequested.eventName;

    constructor(public methods: IMethodRouter, public done: () => void) { }
}